import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReporteTurnoComponent } from './reporte-turno/reporte-turno.component';
import { ReporteDiaComponent } from './reporte-dia/reporte-dia.component';
import { ReporteCarrilComponent } from './reporte-carril/reporte-carril.component';
import { ReactiveFormsModule } from '@angular/forms'
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ReporteTransportistaComponent } from './reporte-transportista/reporte-transportista.component';


@NgModule({
  declarations: [
    ReporteTurnoComponent, 
    ReporteDiaComponent,
    ReporteCarrilComponent,
    ReporteTransportistaComponent
  ],
  exports: [
    ReporteTurnoComponent, 
    ReporteDiaComponent,
    ReporteCarrilComponent,
    ReporteTransportistaComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxDatatableModule
  ]
})
export class ReportesModule { }
